import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { NavService } from '../../_services/_nav.service';
import { Location } from '@angular/common';
import { forkJoin } from 'rxjs';
import { PoliticasCredito } from '../../_models/politicas-credito';
import { PoliticasCreditoOficina } from '../../_models/politicas-credito-oficina';
import { PoliticaCreditoSegmento } from '../../_models/politica-credito-segmento';
import { PoliticasCreditoService } from '../../_services/politicas-credito.service';
import { PoliticasCreditoOficinaService } from '../../_services/politicas-credito-oficina.service';
import { PoliticaCreditoSegmentoService } from '../../_services/politica-credito-segmento.service';

@Component( {
  selector: 'app-politicas-credito-detalle',
  templateUrl: 'politicas-credito-detalle.component.html'
} )

export class PoliticasCreditoDetalleComponent implements OnInit {
  politica: PoliticasCredito;
  lisPoliticaOficinas: PoliticasCreditoOficina[] = [];
  lisPoliticaSegmentos: PoliticaCreditoSegmento[] = [];
  carInformacionInicial = true;
  colOficinas: any[];
  colSegmentos: any[];

  constructor( private polCreditoServicio: PoliticasCreditoService,
               private route: ActivatedRoute,
               private polCreditoOficinaServicio: PoliticasCreditoOficinaService,
               private polCreditoSegmentoServicio: PoliticaCreditoSegmentoService,
               private nav: NavService,
               private location: Location ) {
  }

  ngOnInit(): void {
    this.colOficinas = [
      { field: 'nombreOficina', header: this.nav.buscarMensaje( 'POLITICAS.LBL_OFICINA' ), sort: true }
    ];

    this.colSegmentos = [
      { field: 'nombreSegmento', header: this.nav.buscarMensaje( 'POLITICAS.LBL_SEGMENTO' ), sort: true },
    ];

    this.route.params.subscribe( ( params: Params ) => {
      forkJoin(
        this.polCreditoServicio.obtenerPorId( params[ 'id' ] ),
        this.polCreditoOficinaServicio.obtenerPorIdPoliticaCredito( params[ 'id' ] ),
        this.polCreditoSegmentoServicio.listadoPorPolitica( params[ 'id' ] )
      ).subscribe( ( [ politica, polOficinas, polSegmentos ] ) => {
        this.politica = politica;
        this.lisPoliticaOficinas = polOficinas.filter( x => x.indicadorHabilitado );
        this.lisPoliticaSegmentos = polSegmentos.filter( x => x.indicadorHabilitado );
        this.carInformacionInicial = false;
      } );
    } );
  }

  regresar() {
    this.location.back();
  }
}
